export class UserAccount {
    id = null;
    displayName = null;
    username = null;
    password = null;
    oldPassword = null;
    confirmPassword = null;
    isSetPassword = null;
    changePass = null;
    active = null;
    lastName = null;
    firstName = null;
    dob = null;
    birthPlace = null;
    email = null;
    person = null;
    hasPhoto = null;
    roles = null;
    groups = null;
    org = null;
}